import { Component } from '@angular/core';
import { ToolbarGridThemeComponent } from '../toolbar-grid-theme/toolbar-grid-theme.component';
import { ToolbarGridSidebarComponent } from '../toolbar-grid-sidebar/toolbar-grid-sidebar.component';

@Component({
  selector: 'toolbar-ag-grid',
  imports: [ToolbarGridThemeComponent, ToolbarGridSidebarComponent],
  templateUrl: './toolbar-ag-grid.component.html',
  styleUrl: './toolbar-ag-grid.component.scss',
})
export class ToolbarAgGridComponent {}
